import React,{useEffect} from 'react'
import nineteen from './imgg/person-1.jpg'
import AOS from 'aos';
import 'aos/dist/aos.css'

export default function Contact() {
    useEffect(() => {
        AOS.init({
          duration : 2000
        });
      }, []);
    return (
        <div class='adeola'>
            <div data-aos="fade-up" class="section-header">
                <h1 class="section-heading">Our Team</h1>
                <div class="underline"></div>
            </div>
            <div class='container2'>
                <div  data-aos="fade-right" class='image'>
                    <img src={nineteen} alt=""/>
                </div>
                <div data-aos="fade-right" class='text'>
                The principles of our business have remained steadfast through the years–fast and reliable transport of even the most difficult freight while following all safety and government guidelines.

When you trust us to truck your cargo you’ll know that the safe transport of your goods are in the hands of skilled, qualified professionals and if you are a truck owner, you can be rest assured you have a partner that will enable you to deliver even against odds.

                    <div class='p'>
                        <p><i class="fas fa-envelope"></i> saide@synofordengineering.com</p>
                        <p><i class="fas fa-phone-alt"></i> 08028409511</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
